export default class AdminStatusApi
{
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(AdminStatusApi.BuildPath);
        this.DashAPI.ApiPathMgr.add(AdminStatusApi.DeploymentPath);
    }

    getBuild() {
        return this.DashAPI.CORE.get(AdminStatusApi.BuildPath);
    }
    getDeployment() {
        return this.DashAPI.CORE.get(AdminStatusApi.DeploymentPath);
    }
}

AdminStatusApi.BuildPath = '/api/admin/status/build';
AdminStatusApi.DeploymentPath = '/api/admin/status/deployment';



// WEBPACK FOOTER //
// ./src/DashApi/admin/AdminStatusApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/admin/AdminStatusApi.js